module.exports = __webpack_public_path__ + "assets/c38b3f4f173393d5de838b5e652b98fb.mp3";